<div class="amount-container">
  <div class="minus" (click)="$event.stopPropagation(); amountMinus()" [class.disabled]="amount==min"
    inlineSVG="sot/sot-icon.svg#sot-minus" [setSVGAttributes]="{class: 'icon-amount'}"></div>
  <div class="amount">{{amount}}</div>
  <div class="plus" (click)="$event.stopPropagation(); amountPlus()" [class.disabled]="amount==max"
    inlineSVG="sot/sot-icon.svg#sot-plus" [setSVGAttributes]="{class: 'icon-amount'}"></div>
</div>